import { Fragment } from "react";

/**
 * Dummy component for grouping map controls
 */
const Controls = Fragment;

export default Controls;
export { Controls as Layers };
